<template>
  <div class="analysisreport-channelPerfReport">
    <reportPageTemp
      ref="reportPageTemp"
      :reportParams="reportParams"
      :filter="filter"
    >
      <div class="flex-wrap">
        <div class="flex-al mr10">
          <span class="fs14 color-666">{{
            $t("views.Analysisreport.channelPerfReport.51h4zb879d40")
          }}</span>
          <div class="select-box" style="width: 240px">
            <el-date-picker
              v-model="filter.rang_time"
              type="daterange"
              @change="search"
              :range-separator="
                $t('views.Analysisreport.channelPerfReport.51h4zb87asw0')
              "
              value-format="yyyy-MM-dd"
              :start-placeholder="
                $t('views.Analysisreport.channelPerfReport.51h4zb87b7w0')
              "
              :end-placeholder="
                $t('views.Analysisreport.channelPerfReport.51h4zb87bk00')
              "
              :picker-options="pickerOptions"
            ></el-date-picker>
          </div>
        </div>
        <div class="lines ml16 mr16"></div>
        <div class="flex-al Inquire-box">
          <div class="ipt-box" style="width: 220px">
            <el-input
              v-model="filter.keyword"
              clearable
              placeholder="请输入教师中/英文名，教师编号"
              @clear="search"
              @keyup.enter.native="search"
            ></el-input>
          </div>
          <el-button
            type="primary"
            size="mini"
            class="search-btn fs14"
            @click="search"
            >{{
              $t("views.Analysisreport.channelPerfReport.51h4zb87em80")
            }}</el-button
          >
        </div>
      </div>
    </reportPageTemp>
  </div>
</template>
<script>
import reportPageTemp from "@/components/report/reportTemp";
import storeanalysisreport from "./analysisreport.js";
export default {
  name: "analysisreport-channelPerfReport",
  data() {
    return {
      reportParams: {
        wayString: "gainsByChannel", //传递到子组件的方法名称
        Title: "教师月度目标分析表",
      },
      //筛选
      filter: {
        rang_time: "", //选择时间--必须定义为这个参数
        start_time: "",
        end_time: "",
        keyword: "",
        // frommedia_name: "", //渠道类型
        // channel_id: "", //渠道明细
      },
      // 筛选的下拉列表
      filterList: {
        sourceList: [], //选择渠道类型-下拉数据
        channelList: [], //选择渠道明细-下拉数据
      },
      // 时间限制
      pickerOptions: {
        // disabledDate(time) {
        //   return time.getTime() > Date.now();
        // }
      },
    };
  },
  components: {
    reportPageTemp,
  },
  updated() {},
  created() {
    this.filter.rang_time = [
      this.$Common.getAppointedDate(2, 0).startDate,
      this.$Common.getAppointedDate(2, 0).endDate,
    ];
    (this.filter.start_time = this.$Common.getAppointedDate(2, 0).startDate),
      (this.filter.end_time = this.$Common.getAppointedDate(2, 0).endDate);
    // this.getSourceApi(); // 渠道类型
    // this.getChannelApi("one"); // 渠道明细
  },
  computed: {},
  methods: {
    // 渠道类型
    getSourceApi() {
      storeanalysisreport.getSource({}).then((res) => {
        const { code, data: _jb } = res.data;

        const data = _jb;
        if (code === 200) {
          this.filterList.sourceList = data.list;
        } else {
          this.filterList.sourceList = [];
        }
      });
    },
    // 渠道明细
    getChannelApi(type) {
      storeanalysisreport
        .getChannel({
          channel_medianame: this.filter.frommedia_name,
        })
        .then((res) => {
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.filterList.channelList = data.list;
          } else {
            this.filterList.channelList = [];
          }
          if (type == "search") {
            this.$refs.reportPageTemp.search();
          }
        });
    },
    //检索
    search() {
      this.filter.start_time = this.filter.rang_time
        ? this.filter.rang_time[0]
        : "";
      this.filter.end_time = this.filter.rang_time
        ? this.filter.rang_time[1]
        : "";
      this.$refs.reportPageTemp.search();
    },
    // 渠道类型检索
    frommediaSearch() {
      this.filter.channel_id = "";
      this.getChannelApi("search"); // 渠道明细
    },
  },
  mounted() {
    // this.$nextTick(() => {
    //   if (this.$refs["auto_height_table"]) {
    //     this.tableList.options.tableHeight = this.$Tool.getTableHeight(
    //       this.$refs.auto_height_table.getBoundingClientRect().top + 75
    //     );
    //   }
    // });
  },
};
</script>
<style lang="less">
.analysisreport-channelPerfReport {
  .el-main {
    margin-bottom: 0px;
  }
}
</style>